import { render, staticRenderFns } from "./regionList.vue?vue&type=template&id=d6b0848c&scoped=true&"
import script from "./regionList.vue?vue&type=script&lang=js&"
export * from "./regionList.vue?vue&type=script&lang=js&"
import style0 from "./regionList.vue?vue&type=style&index=0&id=d6b0848c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b0848c",
  null
  
)

export default component.exports